import { Component, OnInit, ChangeDetectionStrategy, Inject, LOCALE_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { CustomerLanding } from '@klickdata/core/customer';
import { MobileService } from '@klickdata/core/mobile';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Component({
    selector: 'app-on-boarding',
    templateUrl: './on-boarding.component.html',
    styleUrls: ['./on-boarding.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnBoardingComponent implements OnInit {
    public isMobile: Observable<boolean>;
    public customerLanding$: Observable<CustomerLanding>;
    constructor(
        protected dialog: MatDialog,
        protected auth: AuthService,
        protected mobile: MobileService,
        @Inject(LOCALE_ID) protected localeId: string
    ) {
        this.isMobile = this.mobile.isMobile().pipe(shareReplay());
    }

    ngOnInit(): void {
        if (this.dialog.openDialogs.length > 0) {
            this.dialog.closeAll();
        }
        this.customerLanding$ = this.auth.getCustomerLanding();
    }
    public openLink() {
        this.localeId === 'en'
            ? window.open('https://klickdata.se/english', '_blank')
            : window.open('https://klickdata.se/produkter-tj%C3%A4nster/lms', '_blank');
    }
    public register() {}
    public login() {}
}
